/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC } from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const AddIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <polygon points="20 10.25 13.75 10.25 13.75 4 10.25 4 10.25 10.25 4 10.25 4 13.75 10.25 13.75 10.25 20 13.75 20 13.75 13.75 20 13.75 20 10.25" />
        <rect fill="none" width="24" height="24" />
      </svg>
    </SvgIcon>
  );
};

export default AddIcon;
